import Avatar from '@material-ui/core/Avatar'
import React from 'react'

const UserAvatar = ({user, ...props}) => <Avatar {...props} src={user?.photoURL} alt={user?.name ?? ''} />

export default UserAvatar
